'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('../layout');

exports["default"] = _layout.Col;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/index.js
 ** module id = 174
 ** module chunks = 0
 **/